import React, { useState, useEffect } from "react";
import "primereact/resources/primereact.min.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import instance from "../../api/api.js";
import { FilterMatchMode } from "primereact/api";
import ProprieteDatatable from "../clients/Proprietaires/ProprieteDatatable";
import { GoPlus } from "react-icons/go";
import { IoPersonOutline } from "react-icons/io5";
import AllCompomentShared from "../../shared/compoments/AllCompomentShared.jsx";

function ListeInactifs() {
  const [biens, setBiens] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const ITEMSFILTER = ["nom", "prenom", "phone", "email"];
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    prenom: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    nom: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    email: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    phone: { value: null, matchMode: FilterMatchMode.EQUALS },
  });
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };

    _filters["global"].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
  };
  const getListBiens = async () => {
    try {
      const response = await instance.get("bienAdmin");
      setBiens(
        response.data.data.filter((item) => item.statut === "Indisponible")
      );
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };
  useEffect(() => {
    getListBiens();
  }, []);

  return (
    <AllCompomentShared
      libelleHeaderComp={"Liste des biens Indisponible"}
      titleStatisticHeaderComp={"Nombre de biens"}
      nbreTotalStatistiqueComp={biens.length}
      // SearchTableLibelleBtn={"Nouveau bien"}
      // SearchTableIsBtn={true}
      SearchTableIsSearch={true}
      placeholderInputSearch={"Recherche"}
      globalFilterValue={globalFilterValue}
      onGlobalFilterChange={onGlobalFilterChange}
      SearchTableNameRouteBtn={"/creation-bien"}
      SearchTableIconeBtn={<GoPlus />} //import { GoPlus } from "react-icons/go";
      iconeStatistiqueHeader={<IoPersonOutline fontSize={"2em"} />} //import { IoPersonOutline } from "react-icons/io5";
      isLoading={isLoading}>
      <ProprieteDatatable
        items={biens}
        itemsForFilter={ITEMSFILTER}
        filters={filters}
        disponibleOrIndisponible="Disponible"
        getListBiens={getListBiens}
      />
    </AllCompomentShared>
  );
}

export default ListeInactifs;
